
import { useState } from 'react';

interface Product {
  id: number;
  name: string;
  brand: string;
  category: string;
  price: string;
  image: string;
  description: string;
  features: string[];
  specifications: {
    [key: string]: string;
  };
  datasheet?: string;
}

interface ProductsGridProps {
  onQuoteClick: () => void;
}

export default function ProductsGrid({ onQuoteClick }: ProductsGridProps) {
  const [selectedCategory, setSelectedCategory] = useState('all');

  const products = [
    {
      id: 1,
      name: "XVR4232AN-I/T",
      brand: "Dahua",
      category: "recorders",
      price: "Sur demande",
      image: "https://materialfile.dahuasecurity.com/uploads/cpq/prm-os-srv-res/smart/formal/Product/HQ/1_0_01_01_16752/ProductImage/1_0_01_01_16752_1084823871_thumb.png",
      description: "32CH Penta-brid 1080N/720P 1U 2HDDs WizSense Digital Video Recorder",
      features: [
        "32 canaux d'entrée analogique BNC",
        "Support HDCVI/AHD/TVI/CVBS auto-détection",
        "Jusqu'à 20 canaux IP (6 MP max par canal)",
        "32 canaux SMD Plus pour filtrage humain/véhicule"
      ],
      specifications: {
        "Processeur": "Processeur de qualité industrielle",
        "Système": "Linux embarqué",
        "Entrées analogiques": "32 ports BNC HDCVI/AHD/TVI/CVBS",
        "Entrées IP": "Jusqu'à 20 canaux (6 MP max)"
      },
      datasheet: "https://materialfile.dahuasecurity.com/uploads/cpq/prm-os-srv-res/smart/datasheetzipfiles/XVR4232AN-I_T_S0_datasheet_20250523.pdf"
    },
    {
      id: 2,
      name: "XVR4216AN-I/T",
      brand: "Dahua",
      category: "recorders",
      price: "Sur demande",
      image: "https://materialfile.dahuasecurity.com/uploads/cpq/prm-os-srv-res/smart/formal/Product/HQ/1_0_01_01_16751/ProductImage/1_0_01_01_16751_1084810443_crop_thumb.png",
      description: "16CH Penta-brid 1080N/720P 1U 2HDDs WizSense Digital Video Recorder",
      features: [
        "16 canaux d'entrée analogique BNC",
        "Support HDCVI/AHD/TVI/CVBS auto-détection",
        "Jusqu'à 18 canaux IP (6 MP max par canal)",
        "16 canaux SMD Plus pour filtrage humain/véhicule",
        "Communication bidirectionnelle coaxiale 16 canaux",
        "Compression Smart H.265+ et H.265",
        "16 canaux AI Coding pour économie stockage",
        "Bande passante entrante: 64 Mbps",
        "2 ports SATA (16 TB max par disque)",
        "Sortie HDMI/VGA",
        "Alimentation 12 VDC, 4 A"
      ],
      specifications: {
        "Processeur": "Processeur de qualité industrielle",
        "Système": "Linux embarqué",
        "Entrées analogiques": "16 ports BNC HDCVI/AHD/TVI/CVBS",
        "Entrées IP": "Jusqu'à 18 canaux (6 MP max)",
        "Résolution": "1080p@25/30 fps, 720p@25/30 fps",
        "Compression": "AI Coding, Smart H.265+, H.265, Smart H.264+, H.264",
        "Stockage": "2 ports SATA, 16 TB max par disque",
        "Réseau": "1 port Ethernet 10/100 Mbps",
        "Alimentation": "12 VDC, 4 A",
        "Consommation": "<10 W (sans HDD)",
        "Dimensions": "375.0 × 289.6 × 53.0 mm",
        "Poids": "1.61 kg",
        "Température": "-10°C à +55°C"
      },
      datasheet: "https://materialfile.dahuasecurity.com/uploads/cpq/prm-os-srv-res/smart/datasheetzipfiles/XVR4216AN-I_T_S0_datasheet_20250523.pdf"
    },
    {
      id: 3,
      name: "XVR4104HS-I/T",
      brand: "Dahua",
      category: "recorders",
      price: "Sur demande",
      image: "https://materialfile.dahuasecurity.com/uploads/cpq/prm-os-srv-res/smart/formal/Product/HQ/1_0_01_01_16744/ProductImage/1_0_01_01_16744_1154865367_crop_thumb.png",
      description: "4CH Penta-brid 1080N/720P Compact 1U 1HDD WizSense Digital Video Recorder",
      features: [
        "4 canaux d'entrée analogique BNC",
        "Support HDCVI/AHD/TVI/CVBS auto-détection",
        "Jusqu'à 5 canaux IP (4 MP max par canal)",
        "4 canaux SMD Plus pour filtrage humain/véhicule",
        "Communication bidirectionnelle coaxiale 4 canaux",
        "Compression Smart H.265+ et H.265",
        "4 canaux AI Coding pour économie stockage",
        "Bande passante entrante: 32 Mbps",
        "1 port SATA (16 TB max)",
        "Sortie HDMI/VGA",
        "Format compact 1U",
        "Alimentation 12 VDC, 1.5 A"
      ],
      specifications: {
        "Processeur": "Processeur de qualité industrielle",
        "Système": "Linux embarqué",
        "Entrées analogiques": "4 ports BNC HDCVI/AHD/TVI/CVBS",
        "Entrées IP": "Jusqu'à 5 canaux (4 MP max)",
        "Résolution": "1080p@25/30 fps, 720p@50/60 fps, 720p@25/30 fps",
        "Compression": "AI Coding, Smart H.265+, H.265, Smart H.264+, H.264",
        "Stockage": "1 port SATA, 16 TB max",
        "Réseau": "1 port Ethernet 10/100 Mbps",
        "Alimentation": "12 VDC, 1.5 A",
        "Consommation": "<4 W (sans HDD)",
        "Dimensions": "260.0 × 237.8 × 47.6 mm",
        "Poids": "0.89 kg",
        "Température": "-10°C à +55°C"
      },
      datasheet: "https://materialfile.dahuasecurity.com/uploads/cpq/prm-os-srv-res/smart/datasheetzipfiles/XVR4104HS-I_T_S0_datasheet_20250523.pdf"
    },
    {
      id: 4,
      name: "XVR5232AN-5M-I3/T",
      brand: "Dahua",
      category: "recorders",
      price: "Sur demande",
      image: "https://materialfile.dahuasecurity.com/uploads/cpq/prm-os-srv-res/smart/formal/Product/HQ/1_0_01_01_16827/ProductImage/1_0_01_01_16827_1084823871_crop_thumb.PNG",
      description: "32CH Penta-brid 5MP 1U 2HDDs WizSense Digital Video Recorder",
      features: [
        "32 canaux d'entrée analogique BNC",
        "Support HDCVI/AHD/TVI/CVBS auto-détection",
        "Jusqu'à 48 canaux IP (8 MP max par canal)",
        "32 canaux SMD Plus pour filtrage humain/véhicule",
        "8 canaux AcuPick pour recherche cible efficace",
        "8 canaux protection périmétrique IA",
        "4 canaux reconnaissance faciale",
        "Communication bidirectionnelle coaxiale 32 canaux",
        "16 canaux AI Coding pour économie stockage",
        "Bande passante entrante: 192 Mbps",
        "2 ports SATA (16 TB max par disque)"
      ],
      specifications: {
        "Processeur": "Processeur de qualité industrielle",
        "Système": "Linux embarqué",
        "Entrées analogiques": "32 ports BNC HDCVI/AHD/TVI/CVBS",
        "Entrées IP": "Jusqu'à 48 canaux (8 MP max)",
        "Résolution": "5 MP@25 fps, 4 MP@25/30 fps, 1080p@25/30 fps",
        "Compression": "AI Coding, Smart H.265+, H.265, Smart H.264+, H.264",
        "AcuPick": "8 canaux (1080P)",
        "Protection périmétrique": "8 canaux, 10 règles IVS par canal",
        "Reconnaissance faciale": "4 canaux, 10 bases de données",
        "SMD Plus": "32 canaux par enregistreur",
        "Stockage": "2 ports SATA, 16 TB max par disque",
        "Réseau": "1 port Ethernet 10/100/1000 Mbps",
        "Alimentation": "12 VDC, 5 A",
        "Consommation": "<16 W (sans HDD)",
        "Dimensions": "375.0 × 289.6 × 53.0 mm",
        "Poids": "1.90 kg",
        "Température": "-10°C à +55°C"
      },
      datasheet: "https://materialfile.dahuasecurity.com/uploads/cpq/prm-os-srv-res/smart/datasheetzipfiles/XVR5232AN-5M-I3_T_S0_datasheet_202507111.pdf"
    },
    {
      id: 5,
      name: "XVR5116HS-5M-I3/T",
      brand: "Dahua",
      category: "recorders",
      price: "Sur demande",
      image: "https://materialfile.dahuasecurity.com/uploads/cpq/prm-os-srv-res/smart/formal/Product/HQ/1_0_01_01_16820/ProductImage/1_0_01_01_16820_1084760673_crop_thumb.PNG",
      description: "16CH Penta-brid 5MP Compact 1U 1HDD WizSense Digital Video Recorder",
      features: [
        "16 canaux d'entrée analogique BNC",
        "Support HDCVI/AHD/TVI/CVBS auto-détection",
        "Jusqu'à 24 canaux IP (6 MP max par canal)",
        "16 canaux SMD Plus pour filtrage humain/véhicule",
        "8 canaux AcuPick pour recherche cible efficace",
        "8 canaux protection périmétrique IA",
        "4 canaux reconnaissance faciale",
        "Communication bidirectionnelle coaxiale 16 canaux",
        "16 canaux AI Coding pour économie stockage",
        "Bande passante entrante: 128 Mbps",
        "1 port SATA (16 TB max)"
      ],
      specifications: {
        "Processeur": "Processeur de qualité industrielle",
        "Système": "Linux embarqué",
        "Entrées analogiques": "16 ports BNC HDCVI/AHD/TVI/CVBS",
        "Entrées IP": "Jusqu'à 24 canaux (6 MP max)",
        "Résolution": "5 MP@25 fps, 4 MP@25/30 fps, 1080p@25/30 fps",
        "Compression": "AI Coding, Smart H.265+, H.265, Smart H.264+, H.264",
        "AcuPick": "8 canaux (1080P)",
        "Protection périmétrique": "8 canaux, 10 règles IVS par canal",
        "Reconnaissance faciale": "4 canaux, 10 bases de données",
        "SMD Plus": "16 canaux par enregistreur",
        "Stockage": "1 port SATA, 16 TB max",
        "Réseau": "1 port Ethernet 10/100/1000 Mbps",
        "Alimentation": "12 VDC, 2 A",
        "Consommation": "<12 W (sans HDD)",
        "Dimensions": "260.0 × 237.8 × 47.6 mm",
        "Poids": "1.00 kg",
        "Température": "-10°C à +55°C"
      },
      datasheet: "https://materialfile.dahuasecurity.com/uploads/cpq/prm-os-srv-res/smart/datasheetzipfiles/XVR5116HS-5M-I3_T_S0_datasheet_20250715.pdf"
    },
    {
      id: 6,
      name: "XVR5108HS-5M-I3/T",
      brand: "Dahua",
      category: "recorders",
      price: "Sur demande",
      image: "https://materialfile.dahuasecurity.com/uploads/cpq/prm-os-srv-res/smart/formal/Product/HQ/1_0_01_01_16816/ProductImage/1_0_01_01_16816_1084760676_crop_thumb.PNG",
      description: "8CH Penta-brid 5MP Compact 1U 1HDD WizSense Digital Video Recorder",
      features: [
        "8 canaux d'entrée analogique BNC",
        "Support HDCVI/AHD/TVI/CVBS auto-détection",
        "Jusqu'à 12 canaux IP (6 MP max par canal)",
        "8 canaux SMD Plus pour filtrage humain/véhicule",
        "4 canaux AcuPick pour recherche cible efficace",
        "8 canaux protection périmétrique IA",
        "2 canaux reconnaissance faciale",
        "Communication bidirectionnelle coaxiale 8 canaux",
        "8 canaux AI Coding pour économie stockage",
        "Bande passante entrante: 64 Mbps",
        "1 port SATA (16 TB max)"
      ],
      specifications: {
        "Processeur": "Processeur de qualité industrielle",
        "Système": "Linux embarqué",
        "Entrées analogiques": "8 ports BNC HDCVI/AHD/TVI/CVBS",
        "Entrées IP": "Jusqu'à 12 canaux (6 MP max)",
        "Résolution": "5 MP@25 fps, 4 MP@25/30 fps, 1080p@25/30 fps",
        "Compression": "AI Coding, Smart H.265+, H.265, Smart H.264+, H.264",
        "AcuPick": "4 canaux (1080P)",
        "Protection périmétrique": "8 canaux, 10 règles IVS par canal",
        "Reconnaissance faciale": "2 canaux, 10 bases de données",
        "SMD Plus": "8 canaux par enregistreur",
        "Stockage": "1 port SATA, 16 TB max",
        "Réseau": "1 port Ethernet 10/100 Mbps",
        "Alimentation": "12 VDC, 2 A",
        "Consommation": "<7 W (sans HDD)",
        "Dimensions": "260.0 × 237.8 × 47.6 mm",
        "Poids": "1.17 kg",
        "Température": "-10°C à +55°C"
      },
      datasheet: "https://materialfile.dahuasecurity.com/uploads/cpq/prm-os-srv-res/smart/datasheetzipfiles/XVR5108HS-5M-I3_T_S0_datasheet_20250711.pdf"
    },
    {
      id: 7,
      name: "XVR5104HS-5M-I3/T",
      brand: "Dahua",
      category: "recorders",
      price: "Sur demande",
      image: "https://materialfile.dahuasecurity.com/uploads/cpq/prm-os-srv-res/smart/formal/Product/HQ/1_0_01_01_16811/ProductImage/1_0_01_01_16811_1154865368_crop_thumb.PNG",
      description: "4CH Penta-brid 5MP Compact 1U 1HDD WizSense Digital Video Recorder",
      features: [
        "4 canaux d'entrée analogique BNC",
        "Support HDCVI/AHD/TVI/CVBS auto-détection",
        "Jusqu'à 6 canaux IP (6 MP max par canal)",
        "4 canaux SMD Plus pour filtrage humain/véhicule",
        "4 canaux AcuPick pour recherche cible efficace",
        "4 canaux protection périmétrique IA",
        "2 canaux reconnaissance faciale",
        "Communication bidirectionnelle coaxiale 4 canaux",
        "4 canaux AI Coding pour économie stockage",
        "Bande passante entrante: 32 Mbps",
        "1 port SATA (16 TB max)"
      ],
      specifications: {
        "Processeur": "Processeur de qualité industrielle",
        "Système": "Linux embarqué",
        "Entrées analogiques": "4 ports BNC HDCVI/AHD/TVI/CVBS",
        "Entrées IP": "Jusqu'à 6 canaux (6 MP max)",
        "Résolution": "5 MP@25 fps, 4 MP@25/30 fps, 1080p@25/30 fps",
        "Compression": "AI Coding, Smart H.265+, H.265, Smart H.264+, H.264",
        "AcuPick": "4 canaux (1080P)",
        "Protection périmétrique": "4 canaux, 10 règles IVS par canal",
        "Reconnaissance faciale": "2 canaux, 10 bases de données",
        "SMD Plus": "4 canaux par enregistreur",
        "Stockage": "1 port SATA, 16 TB max",
        "Réseau": "1 port Ethernet 10/100 Mbps",
        "Alimentation": "12 VDC, 1.5 A",
        "Consommation": "<5 W (sans HDD)",
        "Dimensions": "260.0 × 237.8 × 47.6 mm",
        "Poids": "0.84 kg",
        "Température": "-10°C à +55°C"
      },
      datasheet: "https://materialfile.dahuasecurity.com/uploads/cpq/prm-os-srv-res/smart/datasheetzipfiles/XVR5104HS-5M-I3_T_S0_datasheet_20250711.pdf"
    },
    {
      id: 8,
      name: "HAC-HDW2249TLM-A-LED",
      brand: "Dahua",
      category: "cameras",
      price: "Sur demande",
      image: "https://material.dahuasecurity.com/uploads/image/20210915/DH-HAC-HDW2249TLM-A-LED_Image_thumb.png",
      description: "2MP Full-color HDCVI Eyeball Camera",
      features: [
        "Imagerie couleur 24/7, Max. 30 fps@1080p",
        "Distance d'éclairage 20 m (65.6 ft)",
        "Super Adapt, 120 dB true WDR, 3D NR",
        "Microphone intégré",
        "Objectif fixe 3.6 mm (2.8 mm optionnel)",
        "Commutable CVI/CVBS/AHD/TVI",
        "IP67, DC 12 V",
        "Capteur CMOS 2MP",
        "Vitesse d'obturation électronique PAL: 1/3 s–1/100,000 s",
        "Rapport S/N > 65 dB",
        "Illumination min. 0.0002 Lux/F1.0"
      ],
      specifications: {
        "Capteur": "2MP CMOS",
        "Résolution max": "1920 (H) × 1080 (V)",
        "Pixels": "2MP",
        "Système de balayage": "Progressif",
        "Vitesse d'obturation": "PAL: 1/3 s–1/100,000 s, NTSC: 1/4 s–1/100,000 s",
        "Rapport S/N": "> 65 dB",
        "Illumination min": "0.0002 Lux/F1.0, 0 Lux éclairage blanc activé",
        "Distance d'éclairage": "20 m (65.6 ft)",
        "Nombre d'illuminateurs": "1",
        "Type d'objectif": "Objectif fixe",
        "Longueur focale": "2.8 mm; 3.6 mm",
        "Ouverture max": "F1.0",
        "Champ de vision": "2.8 mm: H: 106°; V: 55°; D: 125°, 3.6 mm: H: 84°; V: 44°; D: 99°",
        "WDR": "120dB",
        "Réduction de bruit": "3D NR",
        "Alimentation": "12V ±30% DC",
        "Consommation": "Max 4.2W (12V DC, éclairage chaud activé)",
        "Température de fonctionnement": "–40°C à +60°C (–40°F à 140°F)",
        "Indice de protection": "IP67",
        "Dimensions": "φ94 mm × 78 mm (φ3.7\" × 3.1\")",
        "Poids net": "0.34 kg (0.75 lb)"
      },
      datasheet: "https://material.dahuasecurity.com/uploads/cpq/prm-os-srv-res/smart/datasheetzipfiles/HAC-HDW2249TLM-A-LED_S0_datasheet_20240701.pdf"
    },
    {
      id: 9,
      name: "HAC-HDW2249T-A-LED",
      brand: "Dahua",
      category: "cameras",
      price: "Sur demande",
      image: "https://materialfile.dahuasecurity.com/uploads/image/20210928/HAC-HDW2249T-A-LED_thumb.png",
      description: "2MP Full-color HDCVI Eyeball Camera",
      features: [
        "Imagerie couleur 24/7, Max. 30 fps@1080p",
        "Distance d'éclairage 40 m (131.2 ft)",
        "Super Adapt, 120 dB true WDR, 3D NR",
        "Microphone intégré",
        "Objectif fixe 3.6 mm (2.8 mm optionnel)",
        "Commutable CVI/CVBS/AHD/TVI",
        "IP67, DC 12 V",
        "Capteur CMOS 2MP",
        "Vitesse d'obturation électronique PAL: 1/3 s–1/100,000 s",
        "Rapport S/N > 65 dB",
        "2 illuminateurs pour portée étendue"
      ],
      specifications: {
        "Capteur": "2MP CMOS",
        "Résolution max": "1920(H) × 1080(V)",
        "Pixels": "2MP",
        "Système de balayage": "Progressif",
        "Vitesse d'obturation": "PAL: 1/3 s–1/100,000 s, NTSC: 1/4 s–1/100,000 s",
        "Rapport S/N": "> 65 dB",
        "Illumination min": "0.0002 Lux/F1.0, 0 Lux éclairage blanc activé",
        "Distance d'éclairage": "40 m (131.2 ft)",
        "Nombre d'illuminateurs": "2",
        "Type d'objectif": "Objectif fixe",
        "Longueur focale": "2.8 mm; 3.6 mm",
        "Ouverture max": "F1.0",
        "Champ de vision": "2.8 mm: H: 106°; V: 55°; D: 125°, 3.6 mm: H: 84°; V: 44°; D: 99°",
        "WDR": "120dB",
        "Réduction de bruit": "3D NR",
        "Alimentation": "12V ±30% DC",
        "Consommation": "Max 5.8W (12V DC, éclairage chaud activé)",
        "Température de fonctionnement": "–40°C à +60°C (–40°F à 140°F)",
        "Indice de protection": "IP67",
        "Dimensions": "φ106.0 mm × 93.6 mm (φ4.17\" × 3.69\")",
        "Poids net": "0.48 kg (1.06 lb)"
      },
      datasheet: "https://material.dahuasecurity.com/uploads/cpq/prm-os-srv-res/smart/datasheetzipfiles/HAC-HDW2249T-A-LED_S0_datasheet_20240701.pdf"
    },
    {
      id: 10,
      name: "HAC-HFW2249T-A-LED",
      brand: "Dahua",
      category: "cameras",
      price: "Sur demande",
      image: "https://materialfile.dahuasecurity.com/uploads/image/20210928/HAC-HFW2249T-A-LED_thumb.png",
      description: "2MP Full-color HDCVI Bullet Camera",
      features: [
        "Imagerie couleur 24/7, Max. 30 fps@1080p",
        "Distance d'éclairage 20 m (65.6 ft)",
        "Super Adapt, 120 dB true WDR, 3D NR",
        "Microphone intégré",
        "Objectif fixe 3.6 mm (2.8 mm optionnel)",
        "Commutable CVI/CVBS/AHD/TVI",
        "IP67, DC 12 V",
        "Capteur CMOS 2MP",
        "Format Bullet résistant aux intempéries",
        "Rapport S/N > 65 dB",
        "1 illuminateur haute performance"
      ],
      specifications: {
        "Capteur": "2MP CMOS",
        "Résolution max": "1920 (H) × 1080 (V)",
        "Pixels": "2MP",
        "Système de balayage": "Progressif",
        "Vitesse d'obturation": "PAL: 1/3 s–1/100,000 s, NTSC: 1/4 s–1/100,000 s",
        "Rapport S/N": "> 65 dB",
        "Illumination min": "0.0002 Lux/F1.0, 0 Lux éclairage blanc activé",
        "Distance d'éclairage": "20 m (65.6 ft)",
        "Nombre d'illuminateurs": "1",
        "Type d'objectif": "Objectif fixe",
        "Longueur focale": "2.8 mm; 3.6 mm",
        "Ouverture max": "F1.0",
        "Champ de vision": "2.8 mm: H: 106°; V: 55°; D: 125°, 3.6 mm: H: 84°; V: 44°; D: 99°",
        "WDR": "120dB",
        "Réduction de bruit": "3D NR",
        "Alimentation": "12V ±30% DC",
        "Consommation": "Max 4.2W (12V DC, éclairage chaud activé)",
        "Température de fonctionnement": "–40°C à +60°C (–40°F à 140°F)",
        "Indice de protection": "IP67",
        "Dimensions": "205 mm × 91 mm × 91 mm (8.1\" × 3.6\" × 3.6\")",
        "Poids net": "0.36 kg (0.79 lb)"
      },
      datasheet: "https://material.dahuasecurity.com/uploads/cpq/prm-os-srv-res/smart/datasheetzipfiles/HAC-HFW2249T-A-LED_S0_datasheet_20240701.pdf"
    },
    {
      id: 11,
      name: "HAC-HFW2249TU-A-LED",
      brand: "Dahua",
      category: "cameras",
      price: "Sur demande",
      image: "https://materialfile.dahuasecurity.com/uploads/image/20210915/HAC-HFW2249TU-A-LED2_thumb.png",
      description: "2MP Full-color HDCVI Bullet Camera",
      features: [
        "Imagerie couleur 24/7, Max. 30 fps@1080p",
        "Distance d'éclairage 60 m (196.9 ft)",
        "Super Adapt, 120 dB true WDR, 3D NR",
        "Microphone intégré",
        "Objectif fixe 3.6 mm (2.8 mm, 6 mm optionnel)",
        "Commutable CVI/CVBS/AHD/TVI",
        "IP67, DC 12 V",
        "Capteur CMOS 2MP",
        "4 illuminateurs haute puissance",
        "Rapport S/N > 65 dB",
        "Format Bullet longue portée"
      ],
      specifications: {
        "Capteur": "2MP CMOS",
        "Résolution max": "1920 (H) × 1080 (V)",
        "Pixels": "2MP",
        "Système de balayage": "Progressif",
        "Vitesse d'obturation": "PAL: 1/3 s–1/100,000 s, NTSC: 1/4 s–1/100,000 s",
        "Rapport S/N": "> 65 dB",
        "Illumination min": "0.0002 Lux/F1.0, 0 Lux éclairage blanc activé",
        "Distance d'éclairage": "60 m (196.9 ft)",
        "Nombre d'illuminateurs": "4",
        "Type d'objectif": "Objectif fixe",
        "Longueur focale": "2.8 mm; 3.6 mm; 6 mm",
        "Ouverture max": "F1.0",
        "Champ de vision": "2.8 mm: H: 106°; V: 55°; D: 125°, 3.6 mm: H: 84°; V: 44°; D: 99°, 6 mm: H: 57°; V: 31°; D: 67°",
        "WDR": "120dB",
        "Réduction de bruit": "3D NR",
        "Alimentation": "12V ±30% DC",
        "Consommation": "Max 10.2W (12 VDC, éclairage chaud activé)",
        "Température de fonctionnement": "–40°C à +60°C (–40°F à 140°F)",
        "Indice de protection": "IP67",
        "Dimensions": "244.1 mm × 90.4 mm × 90.4 mm (9.61\" × 3.56\" × 3.56\")",
        "Poids net": "0.76 kg (1.68 lb)"
      },
      datasheet: "https://material.dahuasecurity.com/uploads/cpq/prm-os-srv-res/smart/datasheetzipfiles/HAC-HFW2249TU-A-LED_S0_datasheet_20240701.pdf"
    },
    {
      id: 12,
      name: "HAC-HDW2509TLM-A-LED",
      brand: "Dahua",
      category: "cameras",
      price: "Sur demande",
      image: "https://material.dahuasecurity.com/uploads/image/20211209/1_0_01_12_23154_2029477732_thumb.png",
      description: "5MP Full-color HDCVI Eyeball Camera",
      features: [
        "Max 25 fps@5MP (16:9 video output)",
        "120 dB true WDR, 3D NR",
        "Imagerie couleur 24/7",
        "Distance d'éclairage 20 m",
        "Super Adapt",
        "Microphone intégré",
        "Objectif fixe 3.6 mm (2.8 mm optionnel)",
        "Commutable CVI/CVBS/AHD/TVI",
        "IP67, 12 VDC",
        "Capteur CMOS 5MP",
        "Illumination min. 0.0002 Lux/F1.0"
      ],
      specifications: {
        "Capteur": "5MP CMOS",
        "Résolution max": "2880 (H) × 1620 (V)",
        "Pixels": "5MP",
        "Système de balayage": "Progressif",
        "Vitesse d'obturation": "PAL: 1/3 s–1/100,000 s, NTSC: 1/4 s–1/100,000 s",
        "Rapport S/N": "> 65 dB",
        "Illumination min": "0.0002 Lux/F1.0, 0 Lux éclairage chaud",
        "Distance d'éclairage": "20 m (65.6 ft)",
        "Nombre d'illuminateurs": "1 (Éclairage chaud)",
        "Type d'objectif": "Objectif fixe",
        "Longueur focale": "2.8 mm; 3.6 mm",
        "Ouverture max": "F1.0",
        "Champ de vision": "2.8 mm: H: 111°; V: 57°; D: 131°, 3.6 mm: H: 88°; V: 46°; D: 104°",
        "WDR": "120dB",
        "Réduction de bruit": "3D NR",
        "Alimentation": "12V ±30% DC",
        "Consommation": "Max 4.4 W (12 VDC, éclairage chaud activé)",
        "Température de fonctionnement": "–40°C à +60°C (–40°F à 140°F)",
        "Indice de protection": "IP67",
        "Dimensions": "φ94 mm × 85.7 mm (φ3.7\" × 3.37\")",
        "Poids net": "0.35 kg (0.77 lb)"
      },
      datasheet: "https://material.dahuasecurity.com/uploads/cpq/prm-os-srv-res/smart/datasheetzipfiles/HAC-HDW2509TLM-A-LED_S0_datasheet_20240606.pdf"
    },
    {
      id: 13,
      name: "HAC-HDW2509T-A-LED",
      brand: "Dahua",
      category: "cameras",
      price: "Sur demande",
      image: "https://material.dahuasecurity.com/uploads/image/20211209/1_0_01_12_23125_972744913_thumb.png",
      description: "5MP Full-color HDCVI Eyeball Camera",
      features: [
        "Max 25 fps@5MP (16:9 video output)",
        "120 dB true WDR, 3D NR",
        "Imagerie couleur 24/7",
        "Distance d'éclairage 20 m",
        "Super Adapt",
        "Microphone intégré",
        "Objectif fixe 3.6 mm (2.8 mm optionnel)",
        "Commutable CVI/CVBS/AHD/TVI",
        "IP67, 12 VDC",
        "Capteur CMOS 5MP",
        "Illumination min. 0.0002 Lux/F1.0"
      ],
      specifications: {
        "Capteur": "5MP CMOS",
        "Résolution max": "2880 (H) × 1620 (V)",
        "Pixels": "5MP",
        "Système de balayage": "Progressif",
        "Vitesse d'obturation": "PAL: 1/3 s–1/100,000 s, NTSC: 1/4 s–1/100,000 s",
        "Rapport S/N": "> 65 dB",
        "Illumination min": "0.0002 Lux/F1.0, 0 Lux éclairage chaud",
        "Distance d'éclairage": "20 m (65.6 ft)",
        "Nombre d'illuminateurs": "1 (Éclairage chaud)",
        "Type d'objectif": "Objectif fixe",
        "Longueur focale": "2.8 mm; 3.6 mm",
        "Ouverture max": "F1.0",
        "Champ de vision": "2.8 mm: H: 111°; V: 57°; D: 131°, 3.6 mm: H: 88°; V: 46°; D: 104°",
        "WDR": "120dB",
        "Réduction de bruit": "3D NR",
        "Alimentation": "12V ±30% DC",
        "Consommation": "Max 4.4 W (12 VDC, éclairage chaud activé)",
        "Température de fonctionnement": "–40°C à +60°C (–40°F à 140°F)",
        "Indice de protection": "IP67",
        "Dimensions": "φ94 mm × 85.7 mm (φ3.7\" × 3.37\")",
        "Poids net": "0.35 kg (0.77 lb)"
      },
      datasheet: "https://material.dahuasecurity.com/uploads/cpq/prm-os-srv-res/smart/datasheetzipfiles/HAC-HDW2509T-S0_datasheet_20240606.pdf"
    },
    {
      id: 14,
      name: "HAC-HFW2509T-A-LED",
      brand: "Dahua",
      category: "cameras",
      price: "Sur demande",
      image: "https://material.dahuasecurity.com/uploads/image/20211209/1_0_01_12_23125_972744913_thumb.png",
      description: "5MP Full-color HDCVI Bullet Camera",
      features: [
        "Max 25 fps@5MP (16:9 video output)",
        "120 dB true WDR, 3D NR",
        "Imagerie couleur 24/7",
        "Distance d'éclairage 20 m",
        "Super Adapt",
        "Microphone intégré",
        "Objectif fixe 3.6 mm (2.8 mm optionnel)",
        "Commutable CVI/CVBS/AHD/TVI",
        "IP67, 12 VDC",
        "Capteur CMOS 5MP",
        "Format Bullet résistant aux intempéries"
      ],
      specifications: {
        "Capteur": "5MP CMOS",
        "Résolution max": "2880 (H) × 1620 (V)",
        "Pixels": "5MP",
        "Système de balayage": "Progressif",
        "Vitesse d'obturation": "PAL: 1/3 s–1/100,000 s, NTSC: 1/4 s–1/100,000 s",
        "Rapport S/N": "> 65 dB",
        "Illumination min": "0.0002 Lux/F1.0, 0 Lux éclairage chaud",
        "Distance d'éclairage": "20 m (65.6 ft)",
        "Nombre d'illuminateurs": "1 (Éclairage chaud)",
        "Type d'objectif": "Objectif fixe",
        "Longueur focale": "2.8 mm; 3.6 mm",
        "Ouverture max": "F1.0",
        "Champ de vision": "2.8 mm: H: 111°; V: 57°; D: 131°, 3.6 mm: H: 88°; V: 46°; D: 104°",
        "WDR": "120dB",
        "Réduction de bruit": "3D NR",
        "Alimentation": "12V ±30% DC",
        "Consommation": "Max 4.4 W (12 VDC, éclairage chaud activé)",
        "Température de fonctionnement": "–40°C à +60°C (–40°F à 140°F)",
        "Indice de protection": "IP67",
        "Dimensions": "174.5 mm × 72.3 mm × 70.6 mm (6.87\" × 2.85\" × 2.78\")",
        "Poids net": "0.37 kg (0.81 lb)"
      },
      datasheet: "https://material.dahuasecurity.com/uploads/cpq/prm-os-srv-res/smart/datasheetzipfiles/HAC-HFW2509T-A-LED_S0_datasheet_20240606.pdf"
    },
    {
      id: 15,
      name: "HAC-HFW2509TU-A-LED",
      brand: "Dahua",
      category: "cameras",
      price: "Sur demande",
      image: "https://material.dahuasecurity.com/uploads/image/20211209/1_0_01_12_23139_1716285313_thumb.png",
      description: "5MP Full-color HDCVI Bullet Camera",
      features: [
        "Max 25 fps@5MP (16:9 video output)",
        "120 dB true WDR, 3D NR",
        "Imagerie couleur 24/7",
        "Distance d'éclairage 60 m",
        "Super Adapt",
        "Microphone intégré",
        "Objectif fixe 3.6 mm (2.8 mm, 6 mm optionnel)",
        "Commutable CVI/AHD/CVI/CVBS",
        "IP67, DC12V",
        "Capteur CMOS 5MP",
        "4 illuminateurs haute puissance"
      ],
      specifications: {
        "Capteur": "5MP CMOS",
        "Résolution max": "2880 (H) × 1620 (V)",
        "Pixels": "5MP",
        "Système de balayage": "Progressif",
        "Vitesse d'obturation": "PAL: 1/3 s–1/100,000 s, NTSC: 1/4 s–1/100,000 s",
        "Rapport S/N": "> 65 dB",
        "Illumination min": "0.0002 Lux/F1.0, 0 Lux éclairage chaud",
        "Distance d'éclairage": "60 m (196.8 ft)",
        "Nombre d'illuminateurs": "4 (Éclairage chaud)",
        "Type d'objectif": "Objectif fixe",
        "Longueur focale": "2.8 mm; 3.6 mm; 6 mm",
        "Ouverture max": "F1.0",
        "Champ de vision": "2.8 mm: H: 111°; V: 57°; D: 131°, 3.6 mm: H: 88°; V: 46°; D: 104°, 6 mm: H: 59°; V: 32°; D: 67°",
        "WDR": "120 dB",
        "Réduction de bruit": "3D NR",
        "Alimentation": "12V ±30% DC",
        "Consommation": "Max 10.7 W (12 VDC, éclairage chaud activé)",
        "Température de fonctionnement": "–40°C à +60°C (–40°F à 140°F)",
        "Indice de protection": "IP67",
        "Dimensions": "244.1 mm × 90.4 mm × 90.4 mm (9.61\" × 3.56\" × 3.56\")",
        "Poids net": "0.78 kg (1.72 lb)"
      },
      datasheet: "https://material.dahuasecurity.com/uploads/cpq/prm-os-srv-res/smart/datasheetzipfiles/HAC-HFW2509TU-A-LED_S0_datasheet_20240606.pdf"
    },
    {
      id: 16,
      name: "KFP-CF2",
      brand: "Kilsen",
      category: "fire-detection",
      price: "Sur demande",
      image: "https://static.wixstatic.com/media/5f67e9_a4985edbe32046178312dc61d29e61fa~mv2.png/v1/crop/x_272,y_0,w_1981,h_2525/fill/w_266,h_339,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/kfp-cf2.png",
      description: "Panneau de détection incendie conventionnel 2 zones / Konvansiyonel Yangın Alarm Paneli 2 Bölge",
      features: [
        "2 zones de détection incendie",
        "Support langue turque",
        "Design moderne et élégant",
        "Pièces facilement amovibles",
        "Installation rapide et facile",
        "Notifications d'alarme supervisées",
        "Contrôle sirène à distance",
        "Modes jour/nuit",
        "Sortie alimentation 24V DC avec support reset",
        "Niveaux d'accès utilisateur conformes EN54",
        "Zones mixtes",
        "Configuration simple et avancée",
        "Test de marche une personne",
        "Sortie relais standard et supervisée"
      ],
      specifications: {
        "Zones": "2 zones",
        "Normes": "EN54-2, EN54-4, CE",
        "Certification": "CPD, NEN2535, NBNS21-100, BS5839-1",
        "Conformité": "WEEE, RoHS",
        "Détecteurs par zone": "Jusqu'à 20 détecteurs",
        "Sorties relais supervisées": "2 pour contrôle sirène",
        "Sorties relais conventionnelles": "2 pour incendie et défaut",
        "Entrées programmables": "2 pour surveillance et contrôle",
        "Alimentation": "230V AC / 24V DC",
        "Température fonctionnement": "-10°C à +55°C",
        "Langue": "Turc"
      },
      datasheet: "https://www.kilsen.com.tr/_files/ugd/5f67e9_6270bf9400224c87890505502ecb8341.pdf"
    },
    {
      id: 17,
      name: "KFP-CF4",
      brand: "Kilsen",
      category: "fire-detection",
      price: "Sur demande",
      image: "https://static.wixstatic.com/media/5f67e9_f94cfe5d756a438e80b33937be3a620f~mv2.png/v1/crop/x_280,y_0,w_2039,h_2598/fill/w_265,h_338,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/kfp-cf4.png",
      description: "Panneau de détection incendie conventionnel 4 zones / Konvansiyonel Yangın Paneli 4 Bölge",
      features: [
        "4 zones de détection incendie",
        "Support langue turque",
        "Design moderne et élégant",
        "Pièces facilement amovibles",
        "Installation rapide et facile",
        "Notifications d'alarme supervisées",
        "Contrôle sirène à distance",
        "Modes jour/nuit",
        "Sortie alimentation 24V DC avec support reset",
        "Niveaux d'accès utilisateur conformes EN54",
        "Zones mixtes",
        "Configuration simple et avancée",
        "Test de marche une personne",
        "Sortie relais standard et supervisée"
      ],
      specifications: {
        "Zones": "4 zones",
        "Normes": "EN54-2, EN54-4, CE",
        "Certification": "CPD, NEN2535, NBNS21-100, BS5839-1",
        "Conformité": "WEEE, RoHS",
        "Détecteurs par zone": "Jusqu'à 20 détecteurs",
        "Sorties relais supervisées": "4 pour contrôle sirène",
        "Sorties relais conventionnelles": "2 pour incendie et défaut",
        "Entrées programmables": "2 pour surveillance et contrôle",
        "Alimentation": "230V AC / 24V DC",
        "Température fonctionnement": "-10°C à +55°C",
        "Langue": "Turc"
      },
      datasheet: "https://www.kilsen.com.tr/_files/ugd/5f67e9_866bb30803eb40cdbcccc127271e7f23.pdf"
    },
    {
      id: 18,
      name: "KFP-CF8",
      brand: "Kilsen",
      category: "fire-detection",
      price: "Sur demande",
      image: "https://static.wixstatic.com/media/5f67e9_3bc8cad48e9243c4b12397c292599fe5~mv2.png/v1/fill/w_268,h_268,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/kfp-cf8.png",
      description: "Panneau de détection incendie conventionnel 8 zones / Konvansiyonel Yangın Paneli 8 Bölge",
      features: [
        "8 zones de détection incendie",
        "Support langue turque",
        "Design moderne et élégant",
        "Pièces facilement amovibles",
        "Installation rapide et facile",
        "Notifications d'alarme supervisées",
        "Contrôle sirène à distance",
        "Modes jour/nuit",
        "Sortie alimentation 24V DC avec support reset",
        "Niveaux d'accès utilisateur conformes EN54",
        "Zones mixtes",
        "Configuration simple et avancée",
        "Test de marche une personne",
        "Sortie relais standard et supervisée"
      ],
      specifications: {
        "Zones": "8 zones",
        "Normes": "EN54-2, EN54-4, CE",
        "Certification": "CPD, NEN2535, NBNS21-100, BS5839-1",
        "Conformité": "WEEE, RoHS",
        "Détecteurs par zone": "Jusqu'à 20 détecteurs",
        "Sorties relais supervisées": "4 pour contrôle sirène",
        "Sorties relais conventionnelles": "2 pour incendie et défaut",
        "Entrées programmables": "2 pour surveillance et contrôle",
        "Alimentation": "230V AC / 24V DC",
        "Réseau": "Jusqu'à 64 zones",
        "Température fonctionnement": "-10°C à +55°C",
        "Langue": "Turc"
      },
      datasheet: "https://www.kilsen.com.tr/_files/ugd/5f67e9_866bb30803eb40cdbcccc127271e7f23.pdf"
    },
    {
      id: 19,
      name: "KFP-CX3",
      brand: "Kilsen",
      category: "fire-suppression",
      price: "Sur demande",
      image: "https://static.wixstatic.com/media/5f67e9_a4985edbe32046178312dc61d29e61fa~mv2.png/v1/crop/x_272,y_0,w_1981,h_2525/fill/w_266,h_339,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/kfp-cf2.png",
      description: "Panneau de contrôle système extinction automatique 3 zones / Yangın Söndürme Paneli 3 Bölge",
      features: [
        "3 zones de contrôle extinction",
        "Support langue turque",
        "Design moderne et élégant",
        "Compatible systèmes CO2, FM-200, Novec",
        "Installation rapide et facile",
        "Temporisation programmable",
        "Alarme sonore et visuelle",
        "Bouton d'arrêt d'urgence",
        "Sortie relais pour électrovannes",
        "Test manuel et automatique",
        "Niveaux d'accès utilisateur conformes EN54",
        "Configuration simple et avancée"
      ],
      specifications: {
        "Zones": "3 zones",
        "Normes": "EN54-2, EN54-4, CE",
        "Certification": "CPD",
        "Conformité": "WEEE, RoHS",
        "Systèmes compatibles": "CO2, FM-200, Novec",
        "Temporisation": "0-60 secondes programmable",
        "Sortie électrovanne": "24V DC",
        "Alimentation": "230V AC / 24V DC",
        "Température fonctionnement": "-10°C à +55°C",
        "Langue": "Turc"
      },
      datasheet: "https://www.kilsen.com.tr/_files/ugd/5f67e9_866bb30803eb40cdbcccc127271e7f23.pdf"
    },
    {
      id: 20,
      name: "KL731",
      brand: "Kilsen",
      category: "fire-detection",
      price: "Sur demande",
      image: "https://static.wixstatic.com/media/5f67e9_f9d1e9000fe8447f9ba7bc69a6a87f30~mv2.png/v1/fill/w_260,h_260,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/kl731.png",
      description: "Détecteur de fumée optique conventionnel / Konvansiyonel Optik Duman Dedektörü",
      features: [
        "Cellule de détection optique",
        "Grille ultra-fine anti-poussière et insectes",
        "Design esthétique et fin",
        "Certifié EN54 et CPR",
        "Option base innovante pour surfaces irrégulières",
        "Option base à relais",
        "Support langue turque",
        "Installation facile",
        "Haute sensibilité",
        "Faible consommation",
        "LED d'indication d'alarme",
        "Compatible avec tous panneaux conventionnels"
      ],
      specifications: {
        "Type": "Détecteur optique de fumée",
        "Normes": "EN54-7, CPR",
        "Certification": "CE",
        "Sensibilité": "0.08-0.15 dB/m selon EN54-7",
        "Tension": "9-30V DC",
        "Courant veille": "50 μA max",
        "Courant alarme": "60 mA max",
        "Température fonctionnement": "-10°C à +55°C",
        "Humidité": "≤95% RH (sans condensation)",
        "Dimensions": "φ100 mm × 50 mm",
        "Poids": "150 g",
        "Couleur": "Blanc (noir optionnel)",
        "Base": "Standard ou à relais"
      },
      datasheet: "https://www.kilsen.com.tr/_files/ugd/5f67e9_a444ef9a42e4482eb62539cf4345247a.pdf"
    },
    {
      id: 21,
      name: "KZ705R",
      brand: "Kilsen",
      category: "fire-detection",
      price: "Sur demande",
      image: "https://static.wixstatic.com/media/5f67e9_1f0d8428433841b387d8db47376a8470~mv2.png/v1/fill/w_260,h_260,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/kz705r.png",
      description: "Base de détecteur conventionnel à relais / Konvansiyonel Röleli Dedektör Tabanı",
      features: [
        "Base universelle pour détecteurs conventionnels Kilsen",
        "Compense les surfaces rugueuses",
        "Contact indicateur distant disponible",
        "Option couleur noire disponible",
        "Connexion pour LED déportée",
        "Entrée câble arrière standard",
        "Accessoire montage surface disponible",
        "Installation facile",
        "Relais de sortie supervisé",
        "Compatible systèmes alarme et automation",
        "Bornier à vis",
        "Design compact"
      ],
      specifications: {
        "Type": "Base à relais 4 contacts",
        "Compatibilité": "Série KL700 Kilsen",
        "Contacts relais": "1 NO/NF 1A 30V DC",
        "Entrée câble": "Arrière standard, latérale optionnelle",
        "Diamètre câble": "Jusqu'à 25 mm (accessoire S700)",
        "Température fonctionnement": "-10°C à +55°C",
        "Humidité": "≤95% RH (sans condensation)",
        "Matériau": "Plastique ignifuge",
        "Couleur": "Blanc (noir optionnel)",
        "Dimensions": "φ100 mm × 35 mm",
        "Poids": "80 g",
        "Montage": "Plafond ou mural",
        "Certification": "EN54"
      },
      datasheet: "https://www.kilsen.com.tr/_files/ugd/5f67e9_f1ba79544dcb48f394bf3bd80946ec9d.pdf"
    },
    {
      id: 22,
      name: "KZ700",
      brand: "Kilsen",
      category: "fire-detection",
      price: "Sur demande",
      image: "https://static.wixstatic.com/media/5f67e9_f39f6a30fdea42e6afbbce84bb81da1a~mv2.png/v1/fill/w_260,h_260,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/kz700.png",
      description: "Base de détecteur conventionnel / Konvansiyonel Dedektör Tabanı",
      features: [
        "Base universelle pour détecteurs conventionnels",
        "Compense les surfaces rugueuses",
        "Contact indicateur distant disponible",
        "Option couleur noire disponible",
        "Connexion pour LED déportée",
        "Entrée câble arrière standard",
        "Accessoire montage surface disponible",
        "Installation facile",
        "Bornier à vis sécurisé",
        "Design compact et esthétique",
        "Matériau ignifuge",
        "Compatible tous détecteurs KL700"
      ],
      specifications: {
        "Type": "Base standard 4 contacts",
        "Compatibilité": "Détecteurs conventionnels Kilsen",
        "Contacts": "4 bornes à vis",
        "Entrée câble": "Arrière standard, latérale optionnelle",
        "Diamètre câble": "Jusqu'à 25 mm (accessoire S700)",
        "Température fonctionnement": "-10°C à +55°C",
        "Humidité": "≤95% RH (sans condensation)",
        "Matériau": "Plastique ignifuge",
        "Couleur": "Blanc (noir optionnel)",
        "Dimensions": "φ100 mm × 35 mm",
        "Poids": "70 g",
        "Montage": "Plafond ou mural",
        "Certification": "EN54"
      },
      datasheet: "https://www.kilsen.com.tr/_files/ugd/5f67e9_f1ba79544dcb48f394bf3bd80946ec9d.pdf"
    },
    {
      id: 23,
      name: "KL710",
      brand: "Kilsen",
      category: "fire-detection",
      price: "Sur demande",
      image: "https://static.wixstatic.com/media/5f67e9_749a37e42a0e4f6c98bd89ac3ac0d7e3~mv2.png/v1/fill/w_260,h_260,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/kl710.png",
      description: "Détecteur de température conventionnel / Konvansiyonel Sıcaklık Dedektörü",
      features: [
        "Capteur d'augmentation de température",
        "Grille ultra-fine anti-poussière et insectes",
        "Design esthétique et fin",
        "Certifié EN54 et CPR",
        "Option base innovante pour surfaces irrégulières",
        "Option base à relais",
        "Support langue turque",
        "Installation facile",
        "Détection température fixe et différentielle",
        "Faible consommation",
        "LED d'indication d'alarme",
        "Compatible avec tous panneaux conventionnels"
      ],
      specifications: {
        "Type": "Détecteur thermique",
        "Normes": "EN54-5, CPR",
        "Certification": "CE",
        "Température alarme": "58°C ±5°C",
        "Vitesse augmentation": "8°C/min",
        "Tension": "9-30V DC",
        "Courant veille": "50 μA max",
        "Courant alarme": "60 mA max",
        "Température fonctionnement": "-10°C à +55°C",
        "Humidité": "≤95% RH (sans condensation)",
        "Dimensions": "φ100 mm × 50 mm",
        "Poids": "150 g",
        "Couleur": "Blanc (noir optionnel)",
        "Base": "Standard ou à relais"
      },
      datasheet: "https://www.kilsen.com.tr/_files/ugd/5f67e9_aa46e662ef614b69a065176f4df0db6d.pdf"
    },
    {
      id: 24,
      name: "DMN700R",
      brand: "Kilsen",
      category: "fire-detection",
      price: "Sur demande",
      image: "https://static.wixstatic.com/media/5f67e9_732404be07fa4d4b8daf9baeab2932e5~mv2.png/v1/fill/w_260,h_260,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/dmn700.png",
      description: "Bouton d'alarme incendie conventionnel / Konvansiyonel Yangın İhbar Butonu",
      features: [
        "Boîtier rouge",
        "Esthétique avancée",
        "Concept d'installation 'Plug and Play'",
        "Option de montage en surface disponible",
        "Couvercle de protection articulé anti-vandalisme",
        "Résistance interne ou contacts secs NO/NF",
        "Options de rétrocompatibilité avec tout système conventionnel",
        "Test par clé",
        "Évite la casse du verre pendant les tests",
        "Élément en verre remplaçable",
        "Conforme EN54-11",
        "Certification CPD"
      ],
      specifications: {
        "Type": "Bouton d'alarme manuel",
        "Normes": "EN54-11, CPR",
        "Certification": "CE, CPD",
        "Contacts": "1 NO/NF 1A 30V DC",
        "Résistance": "Interne programmable ou contacts secs",
        "Couleur": "Rouge",
        "Élément": "Verre remplaçable ou réarmable",
        "Test": "Par clé sans casser le verre",
        "Montage": "Encastré ou surface",
        "Température fonctionnement": "-10°C à +55°C",
        "Humidité": "≤95% RH (sans condensation)",
        "Dimensions": "90 mm × 90 mm × 45 mm",
        "Poids": "120 g",
        "Protection": "IP24"
      },
      datasheet: "https://www.kilsen.com.tr/_files/ugd/5f67e9_7fbe00d910df48ffaf6436138eb3bd7d.pdf"
    },
    {
      id: 25,
      name: "DMN700Y03",
      brand: "Kilsen",
      category: "fire-suppression",
      price: "Sur demande",
      image: "https://static.wixstatic.com/media/5f67e9_41bd69ab484d468f97f36d6bf6ebe175~mv2.png/v1/fill/w_260,h_260,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/dmn700y03.png",
      description: "Bouton de déclenchement système extinction / Söndürme Sistemi Başlatma Butonu",
      features: [
        "Boîtier jaune",
        "Esthétique avancée",
        "Installation facile (Plug and Play)",
        "Couvercle de protection articulé anti-vandalisme",
        "Rétrocompatibilité",
        "Test par clé",
        "Utilisable avec verre ou élément réarmable",
        "Spécialement conçu pour systèmes extinction automatique",
        "Contact de commutation unipolaire",
        "Connexions communes, NO et NF",
        "Fourni avec verre cassable réarmable et clé de test",
        "Conforme EN54-11"
      ],
      specifications: {
        "Type": "Bouton déclenchement extinction",
        "Normes": "EN54-11, CPR",
        "Certification": "CE, CPD",
        "Contacts": "1 NO/NF 1A 30V DC",
        "Couleur": "Jaune",
        "Élément": "Verre remplaçable ou réarmable",
        "Test": "Par clé sans casser le verre",
        "Montage": "Encastré ou surface",
        "Application": "Systèmes CO2, FM-200, Novec",
        "Température fonctionnement": "-10°C à +55°C",
        "Humidité": "≤95% RH (sans condensation)",
        "Dimensions": "90 mm × 90 mm × 45 mm",
        "Poids": "120 g",
        "Protection": "IP24"
      },
      datasheet: "https://www.kilsen.com.tr/_files/ugd/5f67e9_b53595c1350d428dbd8ad9aebce21777.pdf"
    },
    {
      id: 26,
      name: "AS363",
      brand: "Kilsen",
      category: "fire-detection",
      price: "Sur demande",
      image: "https://static.wixstatic.com/media/5f67e9_10af0fe837c14941bb077b26c7d49909~mv2.png/v1/fill/w_260,h_260,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/as363.png",
      description: "Sirène d'alarme incendie multi-tons / Yangın Alarm Sireni Multi Ton",
      features: [
        "Sortie sonore élevée",
        "Faible consommation de courant",
        "32 tons sélectionnables par l'utilisateur",
        "Synchronisation automatique",
        "Contrôle du volume sonore",
        "Mécanisme de verrouillage anti-vandalisme",
        "Base de montage peu profonde",
        "Câblage direct sur la base",
        "Alarme à deux niveaux",
        "Approuvé VdS",
        "Installation rapide TimeSaver™",
        "Système 'tourner et cliquer'"
      ],
      specifications: {
        "Type": "Sirène multi-tons",
        "Normes": "EN54-3:2001 (tons 1,2,3,6,7,13)",
        "Certification": "VdS, CE",
        "Niveau sonore": "95 dB à 1m",
        "Tons": "32 tons sélectionnables",
        "Tension": "9-30V DC",
        "Courant": "15 mA max",
        "Couleur": "Rouge",
        "Base": "TimeSaver™ série 630",
        "Température fonctionnement": "-10°C à +55°C",
        "Humidité": "≤95% RH (sans condensation)",
        "Protection": "IP21",
        "Dimensions": "φ100 mm × 50 mm",
        "Poids": "180 g"
      },
      datasheet: "https://www.kilsen.com.tr/_files/ugd/5f67e9_3b3a38792a594436ba65ca9e7855abd8.pdf"
    },
    {
      id: 27,
      name: "AS366",
      brand: "Kilsen",
      category: "fire-detection",
      price: "Sur demande",
      image: "https://static.wixstatic.com/media/5f67e9_993a5043b2f548a494bc3ca8f7c1805a~mv2.png/v1/fill/w_260,h_260,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/as366.png",
      description: "Sirène avec flash d'alarme incendie / Yangın Alarm Sireni Flaşörlü",
      features: [
        "Sortie sonore élevée",
        "Faible consommation de courant",
        "32 tons sélectionnables par l'utilisateur",
        "Synchronisation automatique",
        "Contrôle du volume sonore",
        "Mécanisme de verrouillage anti-vandalisme",
        "Base de montage peu profonde",
        "Câblage direct sur la base",
        "Connexions séparées sirène et indicateur visuel",
        "Conforme EN54-3:2001 (tons 1,2,3,6,7,13)",
        "Installation rapide TimeSaver™",
        "Note: Indicateur visuel non conforme EN54-23"
      ],
      specifications: {
        "Type": "Sirène avec flash",
        "Normes": "EN54-3:2001 (tons 1,2,3,6,7,13)",
        "Certification": "CE",
        "Niveau sonore": "95 dB à 1m",
        "Tons": "32 tons sélectionnables",
        "Flash": "LED haute intensité",
        "Tension": "9-30V DC",
        "Courant": "25 mA max (sirène + flash)",
        "Couleur": "Rouge",
        "Base": "TimeSaver™ série 630",
        "Température fonctionnement": "-10°C à +55°C",
        "Humidité": "≤95% RH (sans condensation)",
        "Protection": "IP21",
        "Dimensions": "φ100 mm × 55 mm",
        "Poids": "200 g"
      },
      datasheet: "https://www.kilsen.com.tr/_files/ugd/5f67e9_c65931d81d0b442b87a691e83d0d7e43.pdf"
    },
    {
      id: 28,
      name: "DS-7104NI-Q1/4P/M",
      brand: "Hikvision",
      category: "recorders",
      price: "Sur demande",
      image: "https://ssc.tn/web/image/product.product/3079/image_1024/%5BDS-7104NI-Q1-4P-M%5D%20NVR%20Hikvision%204CH%20POE?unique=d0bf9ca",
      description: "NVR 4 canaux offre une résolution vidéo allant jusqu'à 6 MP et supporte un décodage simultané en H.265+ et H.264 avec une bande passante entrante de 40 Mbps. Compact et puissant, il dispose de sorties HDMI et VGA simultanées, d'une capacité de stockage allant jusqu'à 6 To et d'une interface PoE pour une installation simplifiée.",
      features: [
        "4 canaux d'entrée IP",
        "Résolution jusqu'à 6 MP",
        "Bande passante entrante: 40 Mbps",
        "Compression H.265+, H.265, H.264+, H.264"
      ],
      specifications: {
        "Canaux IP": "4 canaux",
        "Résolution max": "6 MP",
        "Bande passante entrante": "40 Mbps",
        "Compression": "H.265+, H.265, H.264+, H.264"
      },
      datasheet: "https://hikvision.com/content/dam/hikvision/products/S000000001/S000000002/S000000003/datasheet_DS-7104NI-Q1-4P-M.pdf"
    },
    {
      id: 29,
      name: "2CE76D0T-ITMFS",
      brand: "Hikvision",
      category: "cameras",
      price: "Sur demande",
      image: "https://ssc.tn/web/image/product.product/3154/image_1024/%5B2CE76D0T-ITMFS%5D%20CAMERA%20DOME%20HIKVISION%202MP%20MICRO?unique=d0bf9ca",
      description: "Caméra 2 MP CMOS offre une résolution de 1920 x 1080, une vision infrarouge jusqu'à 30 mètres, et un objectif fixe disponible en 2,8 mm, 3,6 mm, ou 6 mm. Elle dispose d'un obturateur électronique rapide, d'un mode jour/nuit automatique, et de la gestion WDR. Résistante à l'eau et à la poussière (IP67), elle est idéale pour une utilisation extérieure dans des conditions extrêmes.",
      features: [
        "Capteur CMOS 2 MP",
        "Résolution 1920 x 1080",
        "Vision infrarouge 30 mètres",
        "Microphone intégré"
      ],
      specifications: {
        "Capteur": "2 MP CMOS",
        "Résolution": "1920 × 1080",
        "Vision infrarouge": "30 m",
        "Protection": "IP67"
      },
      datasheet: "https://hikvision.com/content/dam/hikvision/products/S000000001/S000000002/S000000003/datasheet_2CE76D0T-ITMFS.pdf"
    },
    {
      id: 30,
      name: "IDS-7216HUHI-M2/S",
      brand: "Hikvision",
      category: "recorders",
      price: "Sur demande",
      image: "https://ssc.tn/web/image/product.product/3152/image_1024/%5BIDS-7216HUHI-M2-S%5D%20DVR%20Hikvision%2016CH%20UP%20TO%208MP%20%20?unique=d0bf9ca",
      description: "DVR 16 canaux hybride supportant jusqu'à 8MP avec compression H.265+ pour économie de stockage et formats multiples HDCVI/AHD/TVI/CVBS.",
      features: [
        "16 canaux d'entrée analogique",
        "Support HDCVI/AHD/TVI/CVBS",
        "Résolution jusqu'à 8 MP",
        "Compression H.265+ pour économie stockage"
      ],
      specifications: {
        "Canaux analogiques": "16 canaux",
        "Formats supportés": "HDCVI/AHD/TVI/CVBS",
        "Résolution max": "8 MP",
        "Compression": "H.265+, H.265, H.264+, H.264"
      },
      datasheet: "https://hikvision.com/content/dam/hikvision/products/S000000001/S000000002/S000000003/datasheet_IDS-7216HUHI-M2-S.pdf"
    },
    {
      id: 31,
      name: "HWI-D121H-M",
      brand: "Hikvision",
      category: "cameras",
      price: "Sur demande",
      image: "https://ssc.tn/web/image/product.product/3105/image_1024/%5BHWI-D121H-M%5D%20CAMERA%20IP%20DOME%20HIKVISION%202MP?unique=d0bf9ca",
      description: "Caméra IP dôme 2MP avec vision nocturne infrarouge jusqu'à 30 mètres, objectif fixe et protection IP67 pour usage extérieur.",
      features: [
        "Capteur CMOS 2 MP",
        "Vision nocturne infrarouge 30 m",
        "Objectif fixe",
        "Protection IP67"
      ],
      specifications: {
        "Capteur": "2 MP CMOS",
        "Résolution": "1920 × 1080",
        "Vision nocturne": "30 m infrarouge",
        "Protection": "IP67"
      },
      datasheet: "https://ssc.tn/shop/hwi-d121h-m-camera-ip-dome-hikvision-2mp-3105/document/705"
    },
    {
      id: 32,
      name: "DT15",
      brand: "Elkron",
      category: "Détecteurs",
      description: "Détecteur double technologie IR+MW. Portée 15m. Lentille cylindrique. Angle de couverture 90° pour les 2 sections. Fonction anti-animaux avec lentille LT1600113.",
      image: "https://elkron-tunisie.com.tn/webFiles/imagesproduct/197/6dc85f82c10581dbe81c38c157628984.jpeg",
      price: "Prix sur demande",
      features: [
        "Technologie double IR + MW",
        "Fréquence MW 10.525GHz",
        "Portée maximale : 15 m",
        "Couverture MW : 90° horizontal - 36° vertical",
        "Installation murale ou en coin",
        "Tension d'alimentation nominale : 12V +/- 3V",
        "Consommation à 12 V : max. 22 mA",
        "Relais opto : 100mA / 24V",
        "Autoprotection : 100 mA / 30V",
        "Poids : 110 g",
        "Dimensions (L x H x P) : 107 x 61.5 x 43.5 mm",
        "Certification EN50131 1-2-4 Degré 2 Classe 2"
      ],
      datasheet: "#"
    },
    {
      id: 33,
      name: "VXI-ST",
      brand: "Optex",
      category: "Détecteurs extérieurs",
      description: "Détecteur extérieur infrarouge passif anti-animaux domestiques. Portée 12 m. Angle de couverture 90°. 16 zones de détection. Température de -30° à 60° C. Humidité 95% max. Hauteur d'installation de 0,8 à 1,2m.",
      image: "https://elkron-tunisie.com.tn/webFiles/imagesproduct/219/fdb63f39d6342906b80f81eaaa2dc700.png",
      price: "Prix sur demande",
      features: [
        "Hauteur d'installation entre 0,8m et 1,20m",
        "Détection volumétrique avec analyse numérique",
        "Immunité à l'environnement et aux petits animaux",
        "Degré de protection IP55, garanti 2 ans",
        "Portée 12 m avec angle de couverture 90°",
        "16 zones de détection",
        "Température de fonctionnement : -30° à 60° C",
        "Humidité maximale : 95%",
        "Logique SMDA (Super Multi Dimension Analysis)",
        "Alarme par coupure de 2 plans de faisceaux",
        "Sensibilité réglable H / M / L",
        "Protection IP55"
      ],
      datasheet: "https://elkron-tunisie.com.tn/webFiles/pdf/219/optex-vxi-ST.pdf"
    },
    {
      id: 34,
      name: "AJ-REX-W",
      brand: "Ajax",
      category: "Modules et accessoires",
      description: "Répéteur de signal radio sans fils. Répéteur sans fil bidirectionnel. Protocole Jeweller 868MHz. Portée antenne interne espace ouvert 1800 m. Supervision à partir de 12 s. Autoprotection à l'ouverture.",
      image: "https://elkron-tunisie.com.tn/webFiles/imagesproduct/384/2afdd4c3737201a00e482ec84f4dc7af.png",
      price: "Prix sur demande",
      features: [
        "Répéteur sans fil bidirectionnel",
        "Protocole Jeweller 868MHz",
        "Portée antenne interne espace ouvert 1800 m",
        "Supervision à partir de 12 s",
        "Autoprotection à l'ouverture",
        "Anti-brouillage",
        "Batterie de secours",
        "Supporte jusqu'à 99 / 149 (Hub / Hub Plus) appareils sans fil connectés",
        "Compatible avec autres accessoires d'alarme",
        "Alimentation 110-240VAC",
        "Usage intérieur",
        "Inclut support de montage",
        "Couleur blanche",
        "Batterie de secours jusqu'à 35 heures",
        "Température de fonctionnement : -10º C ~ 40º C",
        "Dimensions : 163 (H) x 163 (L) x 36 (P) mm"
      ],
      datasheet: "https://elkron-tunisie.com.tn/webFiles/pdf/384/AJ-REX-W_FR.pdf"
    },
    {
      id: 35,
      name: "HPA700M",
      brand: "Elkron",
      category: "sirenes",
      price: "Sur demande",
      image: "https://elkron-tunisie.com.tn/webFiles/imagesproduct/260/a1e329d5f823df4f366bcf09bfb3d6a6.jpeg",
      description: "Sirène extérieure d'une puissance acoustique 104dB à 3m avec flash LED. Boîtier métallique anti-effraction en aluminium moulé sous pression. Niveau de protection IP43. Protection contre l'inversion de polarité.",
      features: [
        "Puissance acoustique : 104dB à 3m avec flash LED",
        "Boîtier métallique anti-effraction en aluminium moulé",
        "Niveau de protection IP43",
        "Protection contre l'inversion de polarité",
        "Indicateurs d'état du système",
        "Fonctions programmables multiples",
        "Temporisation sonore",
        "8 modes sonores"
      ],
      specifications: {
        "Puissance acoustique": "104dB à 3m avec flash LED",
        "Boîtier": "Aluminium moulé sous pression",
        "Protection": "IP43",
        "Tension": "9 ÷ 15 Vdc",
        "Absorption repos": "7 mA",
        "Absorption alarme": "1600 mA en moyenne",
        "Pression sonore": "> 110 dB (A) @ 1 m",
        "Fréquence": "1400 ÷ 1600 Hz",
        "Autonomie batterie": "60 heures",
        "Classe environnementale": "IV",
        "Température": "-25° C ÷ +70° C",
        "Humidité": "93% max",
        "Protection boîtier": "IP44 / IK08",
        "Dimensions": "203 x 253 x 87 mm",
        "Poids": "1500 g",
        "Performance": "Degré 3 (EN50131-4)"
      },
      datasheet: "https://elkron-tunisie.com.tn/webFiles/pdf/260/HPA700M_datasheet.pdf"
    },
    {
      id: 36,
      name: "AJ-HUB-B",
      brand: "Ajax",
      category: "centrales",
      price: "Sur demande",
      image: "https://elkron-tunisie.com.tn/webFiles/imagesproduct/652/ede9ec08e0f801ab1c9da0a3cd3304c1.png",
      description: "Centrale d'alarme Ajax sans fil professionnelle Grade 2 avec communication Ethernet et GPRS, protocole Jeweller 868MHz, jusqu'à 100 dispositifs sans fil",
      features: [
        "Centrale d'alarme professionnelle",
        "Certification Grade 2",
        "Communication Ethernet et GPRS",
        "Protocole sans fil Jeweller 868MHz",
        "Jusqu'à 100 dispositifs sans fil",
        "Application mobile et logiciel PC",
        "Anti-sabotage à l'ouverture",
        "Jusqu'à 50 utilisateurs"
      ],
      specifications: {
        "Marque": "Ajax",
        "Grade de sécurité": "Grade 2",
        "Fréquence RF": "868 MHz - Protocole Jeweller",
        "Sécurité interne": "Anti-sabotage à l'ouverture",
        "Sirène interne": "Non",
        "Communication": "Ethernet / GPRS",
        "Dispositifs maximum": "100",
        "Nombre d'utilisateurs": "Jusqu'à 50",
        "Matériau boîtier": "Plastique ABS",
        "Alimentation": "AC 110~250 V, 50/60 Hz",
        "Température de fonctionnement": "+5º C ~ 40º C",
        "Dimensions": "163 (H) x 163 (L) x 36 (P) mm"
      },
      datasheet: "https://elkron-tunisie.com.tn/webFiles/pdf/652/AJ-HUB-B_FR.pdf"
    },
    {
      id: 37,
      name: "MP500/8",
      brand: "Elkron",
      category: "centrales",
      price: "Sur demande",
      image: "https://elkron-tunisie.com.tn/webFiles/imagesproduct/136/b6cd72baac81be597eb0e44837cd1b53.png",
      description: "Centrale d'alarme 8 zones extensible à 64 zones avec 8 secteurs, 4 groupes, transmission vocale, numérique et modem via réseau PSTN ou GSM",
      features: [
        "8 entrées extensibles jusqu'à 64",
        "8 secteurs, 4 groupes",
        "8 claviers, 16 lecteurs",
        "32 codes, 32 clés",
        "1000 événements dans l'historique",
        "Transmission vocale, numérique et modem",
        "Contrôle télégraphique à distance par commande DTMF, SMS et internet",
        "Certification EN50131 classe 3"
      ],
      specifications: {
        "Marque": "Elkron",
        "Zones": "8 zones extensibles à 64",
        "Secteurs": "8 secteurs",
        "Groupes": "4 groupes",
        "Claviers": "8 maximum",
        "Lecteurs": "16 maximum",
        "Codes utilisateur": "32",
        "Clés": "32",
        "Historique": "1000 événements",
        "Communication": "PSTN, GSM, Ethernet",
        "Certification": "EN50131 classe 3",
        "Alimentation": "12 Vdc 7 Ah",
        "Dimensions": "238 x 340 x 90 mm"
      },
      datasheet: "https://elkron-tunisie.com.tn/webFiles/pdf/136/MP500_8_FR.pdf"
    },
    {
      id: 38,
      name: "MEDEA/64",
      brand: "Elkron",
      category: "centrales",
      price: "Sur demande",
      image: "https://elkron-tunisie.com.tn/webFiles/imagesproduct/523/01035aa52f8a8181db411cab910d48b9.png",
      description: "Centrale d'alarme avec 6 zones intégrées extensibles à 64 zones avec option de doublement de zone, 2 bus RS485, communication TCP/IP intégrée",
      features: [
        "6 zones intégrées extensibles à 64",
        "Option de doublement de zone",
        "2 bus RS485 pour gérer jusqu'à 16 claviers",
        "32 lecteurs de clés et 20 cartes d'extension",
        "Communication TCP/IP intégrée",
        "Gestion des fonctions domotiques",
        "Communication RF et Zigbee optionnelle",
        "150 utilisateurs et 150 clés"
      ],
      specifications: {
        "Marque": "Elkron",
        "Zones": "6 zones extensibles à 64",
        "Sorties": "1 relais + 1 sortie électrique",
        "Entrée/Sortie": "1 programmable",
        "Bus RS485": "2 bus",
        "Claviers": "16 maximum",
        "Lecteurs": "32 maximum",
        "Cartes d'extension": "20 maximum",
        "Secteurs": "16",
        "Utilisateurs": "150",
        "Clés": "150",
        "Fonctions domotiques": "30",
        "Communication": "Ethernet, GSM, 4G, WiFi, PSTN"
      },
      datasheet: "https://elkron-tunisie.com.tn/webFiles/pdf/523/E_BR_MEDEA.pdf"
    },
    {
      id: 39,
      name: "AJ-DOORPROTECTPLUS-W",
      brand: "Ajax",
      category: "detecteurs",
      price: "Sur demande",
      image: "https://elkron-tunisie.com.tn/webFiles/imagesproduct/383/6f939479aab84f1e64dd948e4f832c91.png",
      description: "Contact magnétique pour porte/fenêtre avec détecteur de vibration et d'inclinaison, protocole Jeweller 868MHz, certification Grade 2",
      features: [
        "Contact magnétique porte/fenêtre",
        "Détecteur avec capteur d'inclinaison et de choc",
        "Protocole sans fil Jeweller 868MHz",
        "Certification Grade 2",
        "1 entrée filaire / 1 anti-sabotage",
        "Alimentation 1 batterie CR123A 3.0 V",
        "Distance de transmission ≤ 1000 m",
        "Durée de vie batterie 5 ans"
      ],
      specifications: {
        "Marque": "Ajax",
        "Fréquence": "868 MHz Jeweller",
        "Grade de sécurité": "Grade 2",
        "Distance de transmission": "≤ 1000 m en espace libre",
        "Entrée auxiliaire": "Contact externe libre de tension NC",
        "Indicateurs LED": "Alarme, sabotage, signal",
        "Matériau boîtier": "Plastique ABS",
        "Batterie": "1 batterie CR123A 3.0 V (durée de vie 5 ans)",
        "Température de fonctionnement": "0º C ~ 50º C",
        "Dimensions émetteur": "90 mm (D) x 20 (Ø) mm",
        "Dimensions aimant": "90 mm (D) x 20 (Ø) mm"
      },
      datasheet: "https://elkron-tunisie.com.tn/webFiles/pdf/383/AJ-DOORPROTECTPLUS-W_FR.pdf"
    }
  ];

  const categories = [
    { id: 'all', name: 'Tous les produits' },
    { id: 'cameras', name: 'Caméras' },
    { id: 'recorders', name: 'Enregistreurs' },
    { id: 'fire-detection', name: 'Détection Incendie' },
    { id: 'fire-suppression', name: 'Extinction Incendie' },
    { id: 'detecteurs', name: 'Détecteurs' },
    { id: 'centrales', name: 'Centrales' },
    { id: 'sirenes', name: 'Sirènes' },
    { id: 'accessories', name: 'Accessoires' }
  ];

  const filteredProducts = selectedCategory === 'all' 
    ? products 
    : products.filter(product => product.category === selectedCategory);

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Notre Gamme de Produits
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Découvrez notre sélection complète d'équipements de sécurité de haute qualité, 
            conçus pour répondre à tous vos besoins de protection.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-product-shop>
          {filteredProducts.map((product, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
              <div className="relative h-64 overflow-hidden">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute top-4 left-4">
                  <span className="bg-blue-600 text-white px-3 py-1 rounded-full text-sm font-medium">
                    {product.brand}
                  </span>
                </div>
              </div>
              
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-2">{product.name}</h3>
                <p className="text-gray-600 mb-4 line-clamp-3">{product.description}</p>
                
                <div className="mb-4">
                  <h4 className="font-semibold text-gray-900 mb-2">Caractéristiques principales :</h4>
                  <ul className="space-y-1">
                    {product.features.map((feature, idx) => (
                      <li key={idx} className="flex items-center text-sm text-gray-600">
                        <i className="ri-check-line text-green-500 mr-2"></i>
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="flex items-center justify-between">
                  <span className="text-2xl font-bold text-blue-600">{product.price}</span>
                  <div className="flex gap-2">
                    <button 
                      onClick={onQuoteClick}
                      className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors duration-300 whitespace-nowrap cursor-pointer"
                    >
                      Devis
                    </button>
                    {product.datasheet && (
                      <a
                        href={product.datasheet}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="bg-gray-600 text-white px-4 py-2 rounded-lg hover:bg-gray-700 transition-colors duration-300 whitespace-nowrap cursor-pointer"
                      >
                        Fiche
                      </a>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
